
import { Poll } from "@mui/icons-material";
import {
  ChatIcon,
  DashboardIcon,
  SettingIcon,

} from "assets/icons/NavIcons";

export const HOME = "HOME";
export const APPOINTMENTS = "APPOINTMENTS";
export const EHR = "EHR";
export const VITALS = "VITALS";
export const DOCUMENTS = "DOCUMENTS";
export const TASKS = "TASKS";
export const PATIENT = "PATIENTS";
export const SETTINGS = "SETTINGS";
export const SURVEY = "SURVEY";
export const CHAT_HISTORY = "CHAT";
export const STORE = "STORE";
export const ME = "ME";
export const INSIGHTS = "INSIGHTS";

export const ROUTER_OBJECT = [
  {
    label: "Dashboard",
    Icon: DashboardIcon,
    identifier: HOME,
    path: "/home/dashboard",
  },
  {
    label: "Chat History",
    Icon: ChatIcon,
    identifier: CHAT_HISTORY,
    path: "/chat/history",
    // className: "step-3",
  },
  {
    label: "Settings",
    // Icon: SvgToMuiIcon(settings_icon),
    Icon: SettingIcon,
    identifier: SETTINGS,
    path: "/settings/me",
    // className: "step-3",
  },
  {
    label: "Survey",
    Icon: Poll,
    identifier: SURVEY,
    path: "/survey/happiness_survey",
  },
];

export const getPathNames = () => {
  return window.location.pathname.split("/");
};
